module.exports = __webpack_public_path__ + "assets/img/02.2ba25c4c.png";